import API from "./API";

export const postSroryApi = async (payload) => {
  try {
    const response = await API.post("/story", payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSroriesApi = async (payload) => {
  try {
    const response = await API.get(
      `/story?page=${payload?.page || 0}&size=${payload?.size || ""}&isRhyme=${
        payload?.isRhyme || false
      }&story=${payload?.story || false}&groupByCategory=${
        payload?.groupByCategory || ""
      }&groupByLanguage=${payload?.groupByLanguage || ""}&lang=${
        payload?.language || ""
      }`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateStoriesApi = async (payload) => {
  try {
    const response = await API.put(`/story/suggestion`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteStoriesApi = async (payload) => {
  try {
    const response = await API.delete(
      `/story/suggestion/${payload?.storySuggestionId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const pauseStoriesApi = async (payload) => {
  try {
    const response = await API.put(
      `/story/pause?storyId=${payload?.storyId || ""}&pause=${payload?.pause}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postStroyCategoryApi = async (payload) => {
  try {
    const response = await API.post(`/add/story/category`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStroyCategoryApi = async (payload) => {
  try {
    const response = await API.get(`/story/category`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateStroyCategoryApi = async (payload) => {
  try {
    const response = await API.put(`/update/story/category`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteStroyCategoryApi = async (payload) => {
  try {
    const response = await API.delete(
      `/delete/story/category?categoryId=${payload?.categoryId || null}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadFileApi = async (payload) => {
  try {
    const formData = new FormData();
    formData.append("file", payload.file);
    const response = await API.post(
      `/upload/file?isAudio=${payload?.isAudio || false}&language=${
        payload?.category || ""
      }`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteFileApi = async (payload) => {
  try {
    const response = await API.delete(`/file?key=${payload?.key || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};
